<template>
  <div id="hygrbgsh">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'hygrbgsh'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/member/approve/personBg/Hygrbgsh.vue